import type { FaireProductEntity } from "../../entity_types/product";

export const p_n6qna87qm7: FaireProductEntity = {
  token: "p_n6qna87qm7",
  type: "product",
  name: "Baby Heart Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/91f1f224cdba5043c9828b3dc6ce48d2b8d85f43ccf80f7be3a543a7e3e1872e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/831d5ad28e12a47a1f97899efbe27c8cb8e188692a479b80a719ef401af45d32.png",
    "https://cdn.faire.com/fastly/80238f44183a86fc3c93c48a848c2bb44cfa97a575cf34ce7a2eaa63036155f7.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:12.452Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
